import { Components, Theme } from '@mui/material';

export default function Button({ palette }: Theme): Components {
  return {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
          '&.Mui-disabled': {
            borderWidth: 2,
          },
        },
        root: {
          variants: [
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                '&:hover': {
                  backgroundColor: palette.secondary.dark,
                },
              },
            },
            {
              props: { variant: 'outlined', color: 'primary' },
              style: {
                borderColor: palette.primary.main,
                '&:hover': {
                  color: palette.secondary.dark,
                  borderColor: palette.secondary.dark,
                },
              },
            },
            {
              props: { variant: 'text', color: 'primary' },
              style: {
                '&:hover': {
                  color: palette.secondary.dark,
                },
              },
            },
          ],
        },
      },
    },
  };
}
